const actions = {
  SEARCH_THIRD_PARTY_SUB_MISSIONS: 'SEARCH_THIRD_PARTY_SUB_MISSIONS',
  SEARCH_THIRD_PARTY_SUB_MISSIONS_ENDED: 'SEARCH_THIRD_PARTY_SUB_MISSIONS_ENDED',
  CREATE_THIRD_PARTY_MISSION: 'CREATE_THIRD_PARTY_MISSION',
  CREATE_THIRD_PARTY_MISSION_ENDED: 'CREATE_THIRD_PARTY_MISSION_ENDED',
  UPDATE_THIRD_PARTY_MISSION: 'UPDATE_THIRD_PARTY_MISSION',
  UPDATE_THIRD_PARTY_MISSION_ENDED: 'UPDATE_THIRD_PARTY_MISSION_ENDED',
  DELETE_THIRD_PARTY_MISSION: 'DELETE_THIRD_PARTY_MISSION',
  DELETE_THIRD_PARTY_MISSION_ENDED: 'DELETE_THIRD_PARTY_MISSION_ENDED',
  SEARCH_MISSIONS: 'SEARCH_MISSIONS',
  SEARCH_MISSIONS_ENDED: 'SEARCH_MISSIONS_ENDED',
  FIND_MISSION: 'FIND_MISSION',
  FIND_MISSION_ENDED: 'FIND_MISSION_ENDED',
  CREATE_MISSION: 'CREATE_MISSION',
  CREATE_MISSION_ENDED: 'CREATE_MISSION_ENDED',
  UPDATE_MISSION: 'UPDATE_MISSION',
  UPDATE_MISSION_ENDED: 'UPDATE_MISSION_ENDED',
  DELETE_MISSION: 'DELETE_MISSION',
  DELETE_MISSION_ENDED: 'DELETE_MISSION_ENDED',
  SEARCH_SUB_MISSION_TRANSACTION_RECORD: 'SEARCH_SUB_MISSION_TRANSACTION_RECORD',
  SEARCH_SUB_MISSION_TRANSACTION_RECORD_ENDED: 'SEARCH_SUB_MISSION_TRANSACTION_RECORD_ENDED',
  SEARCH_MISSION_TRANSACTION_RECORD: 'SEARCH_MISSION_TRANSACTION_RECORD',
  SEARCH_MISSION_TRANSACTION_RECORD_ENDED: 'SEARCH_MISSION_TRANSACTION_RECORD_ENDED',
  SEARCH_MILESTONE_REWARD_TRANSACTION_RECORD: 'SEARCH_MILESTONE_REWARD_TRANSACTION_RECORD',
  SEARCH_MILESTONE_REWARD_TRANSACTION_RECORD_ENDED:
    'SEARCH_MILESTONE_REWARD_TRANSACTION_RECORD_ENDED',
  FIND_SUB_MISSION_TRANSACTION_RECORD: 'FIND_SUB_MISSION_TRANSACTION_RECORD',
  FIND_SUB_MISSION_TRANSACTION_RECORD_ENDED: 'FIND_SUB_MISSION_TRANSACTION_RECORD_ENDED',
  FIND_MILESTONE_REWARD_TRANSACTION_RECORD: 'FIND_MILESTONE_REWARD_TRANSACTION_RECORD',
  FIND_MILESTONE_REWARD_TRANSACTION_RECORD_ENDED: 'FIND_MILESTONE_REWARD_TRANSACTION_RECORD_ENDED',
  FIND_MISSION_TRANSACTION_RECORD: 'FIND_MISSION_TRANSACTION_RECORD',
  FIND_MISSION_TRANSACTION_RECORD_ENDED: 'FIND_MISSION_TRANSACTION_RECORD_ENDED',
  SEARCH_MISSION_CATEGORIES: 'SEARCH_MISSION_CATEGORIES',
  SEARCH_MISSION_CATEGORIES_END: 'SEARCH_MISSION_CATEGORIES_END',
  CREATE_MISSION_CATEGORY: 'CREATE_MISSION_CATEGORY',
  CREATE_MISSION_CATEGORY_END: 'CREATE_MISSION_CATEGORY_END',
  UPDATE_MISSION_CATEGORY: 'UPDATE_MISSION_CATEGORY',
  UPDATE_MISSION_CATEGORY_END: 'UPDATE_MISSION_CATEGORY_END',
  DELETE_MISSION_CATEGORIES: 'DELETE_MISSION_CATEGORIES',
  DELETE_MISSION_CATEGORIES_END: 'DELETE_MISSION_CATEGORIES_END',
  FIND_MISSION_CATEGORY: 'FIND_MISSION_CATEGORY',
  FIND_MISSION_CATEGORY_END: 'FIND_MISSION_CATEGORY_END',
  SEARCH_SUB_MISSION_DETAILS: 'SEARCH_SUB_MISSION_DETAILS',
  SEARCH_SUB_MISSION_DETAILS_ENDED: 'SEARCH_SUB_MISSION_DETAILS_ENDED',
  SEARCH_MISSION_PROGRESS: 'SEARCH_MISSION_PROGRESS',
  SEARCH_MISSION_PROGRESS_ENDED: 'SEARCH_MISSION_PROGRESS_ENDED',
  SEARCH_MISSIONS_WITH_PROGRESS: 'SEARCH_MISSIONS_WITH_PROGRESS',
  SEARCH_MISSIONS_WITH_PROGRESS_ENDED: 'SEARCH_MISSIONS_WITH_PROGRESS_ENDED',
};

export default actions;
